import { render, staticRenderFns } from "./ModalGlobalMessage.vue?vue&type=template&id=df0f1422"
import script from "./ModalGlobalMessage.vue?vue&type=script&lang=js"
export * from "./ModalGlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModalGlobalMessage.vue?vue&type=style&index=0&id=df0f1422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports